import { now } from "@@/shared/date-time/date-time";
import { z } from "zod";
import { productFormFieldBaseZodObject } from "../product-form-field-base";
import type { ProductFormFieldId } from "../product-form-field-id";
import {
    productFormFieldIdFactory,
    productFormFieldIdZodSchema,
} from "../product-form-field-id";
import { productFormFieldSelectOptionZodObject } from "./product-form-field.select-option";

const productFormFieldSelectZodObject = productFormFieldBaseZodObject.merge(
    z.object({
        _id: productFormFieldIdZodSchema,
        type: z.literal("SELECT"),
        defaultValues: z.array(z.string()),
        options: z.array(productFormFieldSelectOptionZodObject),
        required: z.boolean(), // always required
        // TODO! Add support for multi choice and multi select
        // TODO! Since we do not have that yet, for now, "There can be only one"
        minRequired: z.number().int().positive().min(1).max(1),
        maxRequired: z.number().int().positive().min(1).max(1),
    }),
);

type ProductFormField_Select = z.infer<typeof productFormFieldSelectZodObject>;

const factoryParamsZodObject = productFormFieldSelectZodObject.omit({
    _id: true,
    _type: true,
    _createdAt: true,
    type: true,
});
type FactoryParams = z.infer<typeof factoryParamsZodObject>;

const productFormFieldSelectFactory = (
    input: FactoryParams & { _id?: ProductFormFieldId },
): ProductFormField_Select => {
    return {
        ...input,
        _id: input._id ?? productFormFieldIdFactory(),
        _type: "PRODUCT_FIELD",
        required: input.minRequired >= 1,
        _createdAt: now(),
        type: "SELECT",
    };
};

const isProductFormFieldSelect = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    input: any,
): input is ProductFormField_Select => {
    return input?._type === "PRODUCT_FIELD" && input?.type === "SELECT";
};

export {
    isProductFormFieldSelect,
    productFormFieldSelectFactory,
    factoryParamsZodObject as productFormFieldSelectFactoryParamsZodObject,
    productFormFieldSelectZodObject,
};
export type {
    ProductFormField_Select,
    FactoryParams as ProductFormField_SelectFactoryParams,
};
